import { useId } from 'react';
import { useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ReportVatFilter } from '../types';

const ReportVatCheckboxes = () => {
    const { t } = useTranslation('Reports');
    const { values, setFieldValue } = useFormikContext<{ isVat: ReportVatFilter }>();
    const id = useId();
    const withVat = values.isVat === null || values.isVat === 1;
    const withoutVat = values.isVat === null || values.isVat === 0;
    const change = (withVat: boolean, withoutVat: boolean) => void setFieldValue('isVat', withVat ? (withoutVat ? null : 1) : (withoutVat ? 0 : -1));
    return (
        <div className="mb-3 d-flex flex-column gap-2">
            <Form.Check id={`${id}-vat`} type="checkbox" label={t('export.withVat')} checked={withVat} onChange={(event) => change(event.target.checked, withoutVat)} />
            <Form.Check id={`${id}-no-vat`} type="checkbox" label={t('export.withoutVat')} checked={withoutVat} onChange={(event) => change(withVat, event.target.checked)} />
        </div>
    );
};

export default ReportVatCheckboxes;
